import { DOWNLOAD_EXCEL, DOWNLOAD_ZIP} from '../constants/constants';

export const downloadExcel = (data: any) => {
    return {
        type: DOWNLOAD_EXCEL,
        payload: data
    }
}

export const downloadZip=(data:any)=>{
    return{
        type:DOWNLOAD_ZIP,
        payload:data
    }
}


// WEBPACK FOOTER //
// ./src/actions/action.report.tsx